var _path, _path2, _g, _circle, _circle2, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIcPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.85 6.713a6.143 6.143 0 0 1 12.285.041v.07c-.042 2.205-1.273 4.243-2.783 5.836a16.143 16.143 0 0 1-2.873 2.366.744.744 0 0 1-.974 0 15.853 15.853 0 0 1-4.041-3.785A7.86 7.86 0 0 1 1.85 6.733v-.02z",
    fill: "url(#57juur6f4a)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "nldlw5f9wb",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 14,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.85 6.713a6.143 6.143 0 0 1 12.285.041v.07c-.042 2.205-1.273 4.243-2.783 5.836a16.143 16.143 0 0 1-2.873 2.366.744.744 0 0 1-.974 0 15.853 15.853 0 0 1-4.041-3.785A7.86 7.86 0 0 1 1.85 6.733v-.02z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#nldlw5f9wb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f9txag00gc)",
    d: "M.259 0h16v16h-16z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.993,
    cy: 6.832,
    fill: "url(#uo9bqno1yd)",
    r: 1.969
  })), /*#__PURE__*/React.createElement("mask", {
    id: "pth7g10bae",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 4,
    width: 4,
    height: 5
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.993,
    cy: 6.832,
    fill: "#fff",
    r: 1.969
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pth7g10bae)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ybi53a9rgf)",
    d: "M5.259 4.001h5v5h-5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "57juur6f4a",
    x1: 1.85,
    y1: 0.591,
    x2: 1.85,
    y2: 15.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f9txag00gc",
    x1: 0.259,
    y1: 0,
    x2: 0.259,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uo9bqno1yd",
    x1: 6.024,
    y1: 4.863,
    x2: 6.024,
    y2: 8.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ybi53a9rgf",
    x1: 5.259,
    y1: 4.001,
    x2: 5.259,
    y2: 9.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIcPin);
export default __webpack_public_path__ + "static/media/icon-ic-pin.97f6b69a275167dd6f3a7f310b5232cd.svg";
export { ForwardRef as ReactComponent };